import React, { useState } from "react";
import styles from "./Jobs.module.scss";
import cx from "classnames";
import Button from "@components/Button";
import { useTranslationContext } from "@providers/TranslationProvider";
import Icons from "@gstyles/styleguide/icons";

interface IProps {
  data: {
    location: string;
    position: string;
    content: string | React.ReactNode;
    description: string | React.ReactNode;
    workPlace?: string;
    jobTitle?: string;
    jobLink?: string;
    closingDate: string;
  };
}

const DEFAULT_LINK_JOB = "https://www.hoteljob.vn/gian-tuyen-dung/25632-cong-ty-tnhh-amanaki";

export default function JobItem({ data }: IProps) {
  const [expand, setExpand] = useState(false);
  const { i18n } = useTranslationContext();
  return (
    <div className={cx("flex flex-col justify-center", styles.item)}>
      <div className="flex items-center">
        <div className={cx(styles.locationPositionWrapper)}>
          <div className={cx(styles.location)}>{data.workPlace}</div>
          <span className={cx("mx-3", styles.location, styles.pipeSymbol)}>
            {"|"}
          </span>
          <div className={cx(styles.position)}>{data.jobTitle}</div>
        </div>
        <div className="flex items-center gap-2 ml-auto cursor-pointer">
          {expand ? (
            <div className={cx(styles.applyButton)}>
              <Button
                className=""
                label={i18n.t("Button.applyNow")}
                type="primary"
                onClick={() => {
                  if (data.jobLink) {
                    window.open(data.jobLink, '_blank');
                  } else {
                    window.open(DEFAULT_LINK_JOB, '_blank');
                  }
                }}
              />
            </div>
          ) : (
            <div
              className={cx(styles.viewCareerBtn)}
              onClick={() => setExpand(true)}
            >
              {i18n.t("Button.viewCareers")}
            </div>
          )}
          <div onClick={() => setExpand(!expand)}>
            <Icons
              name="arrow-long-narrow-right"
              color="#af915e"
              className={cx(styles.arrowIcon, { [styles.rotate90]: expand })}
            />
          </div>
        </div>
      </div>
      <div
        className={cx("flex flex-col justify-center", styles.contentWrapper, {
          [styles.expandedContentWrapper]: expand,
        })}
      >
        <>
          <div className={cx("mt-6", styles.content)}>{data.description}</div>
          {!!data.closingDate && (
            <div className="flex mt-6">
              <div className={cx(styles.closingDateLabel)}>Closing date:</div>
              <div className={cx("ml-1", styles.closingDateValue)}>
                {data.closingDate}
              </div>
            </div>
          )}
          <div className={cx(styles.mobileApplyBtn)}>
            <Button
              type="primary"
              className=""
              label={i18n.t("Button.applyNow")}
              style={{ width: "100%" }}
              onClick={() => {
                if (data.jobLink) {
                  window.open(data.jobLink, '_blank');
                } else {
                  window.open(DEFAULT_LINK_JOB, '_blank');
                }
              }}
            />
          </div>
        </>
      </div>
    </div>
  );
}
